<div class="container-detail-cart">
    <p-toast/>
    <div class="total " *ngIf="showDetail">
        <div class="px-4">
            <div>
                <span class="">Costo estimado de productos: </span>
                <span class="title">{{total | currency}} </span>
            </div>
            <div>
                <span class="comentario">* Para obtener el costo final de su pedido, debe solicitar su cotización.</span>
            </div>
        </div>
        <div class="btn-solicitar" *ngIf="section == 1">
            <button type="button" class="btn btn-primary" (click)="section=2">Continuar con la Cotización</button>
        </div>
        <div class="btn-solicitar" *ngIf="section == 2">
            <button type="button" class="btn btn-primary" (click)="saveOrder()">Solicitar Cotización</button>
        </div>
    </div>
    <div class="container-products" *ngIf="section == 1">
        <div  *ngFor="let item of listItems, let ix=index">
            <div class="card d-flex card-information">
                <div class="width-img img-cart">
                    <img class="h-100 block xl:block mx-auto border-round w-full img-size" [src]="item.imagen.url" [alt]="item.nombre" />
                </div>
                <div class="width-description my-auto">
                    <!-- <div class="card-header">
                        {{item.nombre}}
                    </div> -->
                    <div class="card-body">
                        <p class="card-text">{{item.nombre}}</p>
                    </div>
                </div>
                <div class="width-price d-flex flex-column mx-auto px-auto price-info">
                    <span class="unit-price text-center">{{item.precioUnitario | currency}}</span>
                    @if (showDetail) {
                        <div class="btn-group mt-2" role="group" aria-label="Basic example" >
                            <button type="button" class="btn btn-primary" (click)="less(ix)">-</button>
                            <span class="px-3 py-2">{{item.cantidad}}</span>
                            <button type="button" class="btn btn-primary" (click)="add(ix)">+</button>
                        </div>
                        <button class="btn btn-primary mt-2" (click)="deleteProduct(ix)"><i class="fas fa-trash"></i> Eliminar Producto</button>
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="container-products" *ngIf="section == 2">
        <app-adress-form (adress)="getAddress($event)"></app-adress-form>
    </div>
    <div class="container-products" *ngIf="section == 3">
        <div class="text-center my-5">
            Su solicitud ha sido enviada con éxito.
        </div>

    </div>
    <div class="container-products" *ngIf="section == 0">
        <div class="text-center my-5">
            No se encontraron productos en el carrito.
        </div>

    </div>
</div>